
import { defineComponent, ref, computed, onMounted } from "vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import ApiService from "@/core/services/ApiService";
import { config } from "@/core/helpers/config";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import store from "@/store";
// import store from "@/store";

export default defineComponent({
  name: "topbar",
  components: {
    KTUserMenu,
  },

  setup() {
    const selectedClients = ref([]); 
    const clientList = ref([
      {key: null, name: null}
    ]); 
    let id = store.getters.UserId
    let mailid = store.getters.emailid;
    let accountid = computed(()=> store.getters.AccountId);
    let accountname = computed(()=> store.getters.AccountName);
    ApiService.get(`api/users/getCustomer/${id}`)
      .then((resp) => {
         clientList.value = resp.data.usermodel.map((a) => ({
            key: a.id,
            name: a.username,
          }));
      })
      .catch((a) => {
        console.log("API Error", a);
      });
      onMounted(() => {
        // after clientList data is assigned
        selectedClients.value = accountname.value;
      });
    /**
     * Submit form
     * @param event
     */
    return {
      config,
      selectedClients,
      clientList,
      mailid,
      accountid,
      accountname,
    };
  },
  methods: {
    
    handleClientChange(value) {
      const selectedItem = this.clientList.find(x => x.key === value);
      store.commit(Mutations.SET_ACCOUNT, {
        accountId: String(selectedItem?.key),
        accountName: selectedItem?.name
      });     
    },

    toggle(event) {
      // added event as second arg
      event.preventDefault();
      // save new config to localStorage
      localStorage.setItem("config", JSON.stringify(config.value));
    },
  },
});
